(function($) {

	'use strict';

	var init = function() {
		$("a[href*='#']:not([href='#']):not([href='#contact']):not([href='#cookies'])").click(anchorScroll)
	}
	
	var anchorScroll = function(e){

        var delay = 0;

        var customTrim = parseInt($('header').height(), 10) + parseInt($('header').css('top'), 10);

		if($('.header__nav__menu').hasClass('active')) {
			$('.header__nav__burger--bar').toggleClass('active');
			$('.header__nav__menu').toggleClass('active');
			$('html').toggleClass('active');			
			letScroll();
			delay = 300;
		}
        if(
            location.hostname == this.hostname
            && this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"")
        ){
			e.preventDefault();
            var anchor = $(this.hash);
            if(anchor.length){
				if($(window).width() > 991) {
					$("html, body").delay(delay).animate({scrollTop: anchor.offset().top - customTrim}, 1500);
				} else {
					$("html, body").delay(delay).animate({scrollTop: anchor.offset().top - 61}, 1500);
				}				
            } else{
				$("html, body").delay(delay).animate({scrollTop: 0}, 1500);	
			}
        }
	};
	
	var letScroll = function() {
		$(document).unbind('touchmove');
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
